//REACT
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

//YUP
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

//MUI
import Box from "@mui/material/Box";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import {
  Collapse,
  List,
  ListItemButton,
  ListItemText,
  MenuItem,
  Typography,
} from "@mui/material";

//COMPONENTS
import { CustomScrollbar } from "../../../customScrollbar/CustomScrollbar";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { DatePicker } from "@mui/lab";
import RoleBasedContent from "../../../../../contents/RoleBasedContent";

const schema = yup.object().shape({
  ofrCode: yup.string(),
  famCode: yup.string(),
  promoEvent: yup.string(),
  associated: yup.boolean(),
  machineCode: yup.boolean(),
  sentToSap: yup.boolean(),
  user: yup.string(),
  associatedDate: yup.date(),
  burnDate: yup.date(),
  promoAssociatedDate: yup.date(),
  voucherType: yup.string(),
  sentToCDP: yup.boolean(),
  sentToSF: yup.boolean(),
  burnChannel: yup.string(),
  sentPromotionToCDP: yup.boolean(),
  sentPromotionToSF: yup.boolean(),
  promoAssociated: yup.boolean(),
  // externalPromoCode: yup.object().shape({
  //   code: yup.string(),
  //   associated: yup.boolean(),
  //   associatedDate: yup.date(),
  //   voucherType: yup.string(),
  // }),
});

const Form = ({ mode = "create", handleSave, currentProduct }) => {
  const isEdit = mode === "edit";
  const { id, dataCreation, ...voucherInt } = currentProduct;

  const defaultValues = {
    code: "",
    ofrCode: "",
    famCode: "",
    promoEvent: "",
    associated: false,
    machineCode: false,
    sentToSap: false,
    user: "",
    associatedDate: null,
    burnDate: null,
    promoAssociatedDate: null,
    promoUser:"",
    voucherType: "",
    sentToCDP: false,
    sentToSF: false,
    burnChannel: "",
    sentPromotionToCDP: false,
    sentPromotionToSF: false,
    promoAssociated: false,
    ...voucherInt,
  };

  const form = useForm({
    defaultValues,
    mode: "onBlur",
    //resolver: yupResolver(schema),
  });

  const { register, handleSubmit, formState, reset, setValue } = form;
  const { errors, isValid, isDirty } = formState;

  useEffect(() => {
    reset(defaultValues);
  }, [currentProduct]);

  const onSubmit = (data) => {
    handleSave(data);
  };

  //NESTED LIST
  const [open, setOpen] = useState(false);
  const handleClick = () => setOpen(!open);

  //BOOLEANS LOGIC

  const booleanOptions = [true, false];

  //Associated

  const [selectedAssociated, setSelectedAssociated] = useState(
    currentProduct.Associated || ""
  );

  const handleSelectAssociated = (associated) => {
    setSelectedAssociated(associated);
    setValue("associated", associated);
  };

  useEffect(() => {
    setSelectedAssociated(currentProduct.associated || "false");
    reset(defaultValues);
  }, [currentProduct]);

  //Machine Code

  const [selectedMachineCode, setSelectedMachineCode] = useState(
    currentProduct.machineCode || ""
  );

  const handleSelectMachineCode = (machineCode) => {
    setSelectedMachineCode(machineCode);
    setValue("machineCode", machineCode);
  };

  useEffect(() => {
    setSelectedMachineCode(currentProduct.machineCode || "false");
    reset(defaultValues);
  }, [currentProduct]);

  //Sent To Sap

  const [selectedSentToSap, setSelectedSentToSap] = useState(
    currentProduct.SentToSap || ""
  );

  const handleSelectSentToSap = (sentToSap) => {
    setSelectedSentToSap(sentToSap);
    setValue("sentToSap", sentToSap);
  };

  useEffect(() => {
    setSelectedSentToSap(currentProduct.sentToSap || "false");
    reset(defaultValues);
  }, [currentProduct]);

  //Sent To CDP

  const [selectedSentToCDP, setSelectedSentToCDP] = useState(
    currentProduct.SentToCDP || ""
  );

  const handleSelectSentToCDP = (sentToCDP) => {
    setSelectedSentToCDP(sentToCDP);
    setValue("sentToCDP", sentToCDP);
  };

  useEffect(() => {
    setSelectedSentToCDP(currentProduct.sentToCDP || "false");
    reset(defaultValues);
  }, [currentProduct]);

  //Sent To SF

  const [selectedSentToSF, setSelectedSentToSF] = useState(
    currentProduct.SentToSF || ""
  );

  const handleSelectSentToSF = (sentToSF) => {
    setSelectedSentToSF(sentToSF);
    setValue("sentToSF", sentToSF);
  };

  useEffect(() => {
    setSelectedSentToSF(currentProduct.sentToSF || "false");
    reset(defaultValues);
  }, [currentProduct]);

  //Sent Promotion To CDP

  const [selectedSentPromotionToCDP, setSelectedSentPromotionToCDP] = useState(
    currentProduct.SentPromotionToCDP || ""
  );

  const handleSelectSentPromotionToCDP = (sentPromotionToCDP) => {
    setSelectedSentPromotionToCDP(sentPromotionToCDP);
    setValue("sentPromotionToCDP", sentPromotionToCDP);
  };

  useEffect(() => {
    setSelectedSentPromotionToCDP(currentProduct.sentPromotionToCDP || "false");
    reset(defaultValues);
  }, [currentProduct]);

  //Sent Promotion To SF

  const [selectedSentPromotionToSF, setSelectedSentPromotionToSF] = useState(
    currentProduct.SentPromotionToSF || ""
  );

  const handleSelectSentPromotionToSF = (sentPromotionToSF) => {
    setSelectedSentPromotionToSF(sentPromotionToSF);
    setValue("sentPromotionToSF", sentPromotionToSF);
  };

  useEffect(() => {
    setSelectedSentPromotionToSF(currentProduct.sentPromotionToSF || "false");
    reset(defaultValues);
  }, [currentProduct]);

  //Promo Associated

  const [selectedPromoAssociated, setSelectedPromoAssociated] = useState(
    currentProduct.PromoAssociated || ""
  );

  const handleSelectPromoAssociated = (promoAssociated) => {
    setSelectedPromoAssociated(promoAssociated);
    setValue("promoAssociated", promoAssociated);
  };

  useEffect(() => {
    setSelectedPromoAssociated(currentProduct.promoAssociated || "false");
    reset(defaultValues);
  }, [currentProduct]);

  //END OF BOOLEANS LOGIC

  return (
    <CustomScrollbar>
      <Box
        id="voucherIntForm"
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
        maxWidth="95%"
        maxHeight="35vw"
      >
        <Grid2 container spacing={3}>
          <Grid2 xs={12}>
            <Typography variant="h3" color="primary">
              Voucher SAP {isEdit ? "details" : "creation"}
            </Typography>
          </Grid2>
          <Grid2 item xs={12} lg={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Ofr Code"
              color="primary"
              fullWidth
              {...register("ofrCode")}
            />
          </Grid2>
          <Grid2 item xs={12} lg={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Fam Code"
              color="primary"
              fullWidth
              {...register("famCode")}
            />
          </Grid2>
          <Grid2 item xs={12} lg={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Promo Event"
              color="primary"
              fullWidth
              {...register("promoEvent")}
            />
          </Grid2>
          <Grid2 item xs={12} lg={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="User"
              color="primary"
              fullWidth
              {...register("user")}
            />
          </Grid2>
          <Grid2 item xs={12} lg={6}>
            <TextField
              disabled={isEdit}
              InputLabelProps={{ shrink: true }}
              label="Associated date"
              type="date"
              color="primary"
              fullWidth
              error={!!errors.associatedDate}
              helperText={errors.associatedDate?.message}
              {...register("associatedDate")}
            />
            <DatePicker />
          </Grid2>

          <Grid2 item xs={12} lg={6}>
            <TextField
              disabled={isEdit}
              InputLabelProps={{ shrink: true }}
              label="Burn date"
              shrink="true"
              type="date"
              color="primary"
              fullWidth
              error={!!errors.burnDate}
              helperText={errors.burnDate?.message}
              {...register("burnDate")}
            />
            <DatePicker />
          </Grid2>
          <Grid2 item xs={12} lg={5}>
            <TextField
              disabled={isEdit}
              InputLabelProps={{ shrink: true }}
              label="Promo Associated Date"
              shrink="true"
              type="date"
              color="primary"
              fullWidth
              error={!!errors.promoAssociatedDate}
              helperText={errors.promoAssociatedDate?.message}
              {...register("promoAssociatedDate")}
            />
            <DatePicker />
          </Grid2>
          <Grid2 item xs={12} lg={7}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Promo User"
              color="primary"
              fullWidth
              {...register("promoUser")}
            />
          </Grid2>
          <Grid2 item xs={12} lg={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Voucher Type"
              color="primary"
              fullWidth
              {...register("voucherType")}
            />
          </Grid2>

          <Grid2 item xs={12} lg={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Burn Channel"
              color="primary"
              fullWidth
              {...register("burnChannel")}
            />
          </Grid2>

          {/* BOOLEANS */}
          <Grid2 item xs={12} sm={6} lg={3}>
            <TextField
              disabled
              InputLabelProps={{ shrink: true }}
              label="Associated"
              color="primary"
              fullWidth
              select
              value={selectedAssociated}
              onChange={(event) => handleSelectAssociated(event.target.value)}
              title="Associated"
            >
              {booleanOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  <Typography variant="subtitle2">
                    {option ? "Yes" : "No"}
                  </Typography>
                </MenuItem>
              ))}
            </TextField>
          </Grid2>

          <Grid2 item xs={12} sm={6} lg={3}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Machine Code"
              color="primary"
              fullWidth
              select
              value={selectedMachineCode}
              onChange={(event) => handleSelectMachineCode(event.target.value)}
              title="Machine Code"
            >
              {booleanOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  <Typography variant="subtitle2">
                    {option ? "Yes" : "No"}
                  </Typography>
                </MenuItem>
              ))}
            </TextField>
          </Grid2>

          <Grid2 item xs={12} sm={6} lg={3}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Sent to Sap"
              color="primary"
              fullWidth
              select
              value={selectedSentToSap}
              onChange={(event) => handleSelectSentToSap(event.target.value)}
              title="Sent to Sap"
            >
              {booleanOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  <Typography variant="subtitle2">
                    {option ? "Yes" : "No"}
                  </Typography>
                </MenuItem>
              ))}
            </TextField>
          </Grid2>

          <Grid2 item xs={12} sm={6} lg={3}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Sent  to CDP"
              color="primary"
              fullWidth
              select
              value={selectedSentToCDP}
              onChange={(event) => handleSelectSentToCDP(event.target.value)}
              title="Sent  to CDP"
            >
              {booleanOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  <Typography variant="subtitle2">
                    {option ? "Yes" : "No"}
                  </Typography>
                </MenuItem>
              ))}
            </TextField>
          </Grid2>

          <Grid2 item xs={12} sm={6} lg={3}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Sent  to SF"
              color="primary"
              fullWidth
              select
              value={selectedSentToSF}
              onChange={(event) => handleSelectSentToSF(event.target.value)}
              title="Sent  to SF"
            >
              {booleanOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  <Typography variant="subtitle2">
                    {option ? "Yes" : "No"}
                  </Typography>
                </MenuItem>
              ))}
            </TextField>
          </Grid2>

          <Grid2 item xs={12} sm={6} lg={3}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Sent promotion to CDP"
              color="primary"
              fullWidth
              select
              value={selectedSentPromotionToCDP}
              onChange={(event) =>
                handleSelectSentPromotionToCDP(event.target.value)
              }
              title="Sent promotion to CDP"
            >
              {booleanOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  <Typography variant="subtitle2">
                    {option ? "Yes" : "No"}
                  </Typography>
                </MenuItem>
              ))}
            </TextField>
          </Grid2>

          <Grid2 item xs={12} sm={6} lg={3}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Sent Promotion to SF"
              color="primary"
              fullWidth
              select
              value={selectedSentPromotionToSF}
              onChange={(event) =>
                handleSelectSentPromotionToSF(event.target.value)
              }
              title="Sent Promotion to SF"
            >
              {booleanOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  <Typography variant="subtitle2">
                    {option ? "Yes" : "No"}
                  </Typography>
                </MenuItem>
              ))}
            </TextField>
          </Grid2>

          <Grid2 item xs={12} sm={6} lg={3}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Promo Associated"
              color="primary"
              fullWidth
              select
              value={selectedPromoAssociated}
              onChange={(event) =>
                handleSelectPromoAssociated(event.target.value)
              }
              title="Promo Associated"
            >
              {booleanOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  <Typography variant="subtitle2">
                    {option ? "Yes" : "No"}
                  </Typography>
                </MenuItem>
              ))}
            </TextField>
          </Grid2>

          {/* END OF BOOLEANS */}

          <RoleBasedContent>
            <Grid2 xs={12}>
              <Tooltip arrow title={(false && "a") || ""}>
                <LoadingButton
                  type="submit"
                  loading={false}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  sx={{
                    boxShadow: "none",
                    padding: "5px 12px 4px 12px",
                  }}
                  color="primary"
                  onClick={() => {}}
                  // disabled={isDirty && !isValid}
                >
                  Save
                </LoadingButton>
              </Tooltip>
            </Grid2>
          </RoleBasedContent>
        </Grid2>
      </Box>
    </CustomScrollbar>
  );
};

export default Form;
